import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=ba7a621e&scoped=true&lang=pug"
import script from "./Projects.vue?vue&type=script&lang=ts"
export * from "./Projects.vue?vue&type=script&lang=ts"
import style0 from "./Projects.vue?vue&type=style&index=0&id=ba7a621e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7a621e",
  null
  
)

export default component.exports